import { useId } from "react";

/**
 * Hyrvix brand logo mark.
 * Upward chevron (career growth) + two tapering bars (resume).
 * Scales cleanly from 20px to 200px.
 */
export default function HyrvixLogo({ size = 40 }) {
  const uid = useId().replace(/:/g, "");
  const gradId = `hx-bg-${uid}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Hyrvix"
      role="img"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#2563eb" />
          <stop offset="100%" stopColor="#7c3aed" />
        </linearGradient>
      </defs>

      {/* Background rounded square */}
      <rect width="40" height="40" rx="10" fill={`url(#${gradId})`} />

      {/* Upward chevron — represents career lift */}
      <path
        d="M8 24 L20 10 L32 24"
        stroke="white"
        strokeWidth="3.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Resume text lines — long bar */}
      <rect x="8" y="29" width="15" height="3.5" rx="1.75" fill="white" opacity="0.88" />

      {/* Resume text lines — short bar */}
      <rect x="8" y="34.5" width="10" height="3" rx="1.5" fill="white" opacity="0.6" />
    </svg>
  );
}
